import { getGlobalEventsLogs, IEvent, createConsumer, createSubscriber } from '@cian/events-log';
import { ILink } from '../types';

interface IGetLinksListParameters {
  withAdditionalLinks: boolean;
}

const BASE_LINKS = [
  {
    href: 'https://hc.cian.ru/hc/ru',
    text: 'Справочный центр',
    name: 'help',
  },
  {
    href: '/legal-documents/pravila_polzovaniya_sajtom_cian_0/',
    text: 'Юридические документы',
    name: 'legal-documents',
  },
  {
    href: '/price/?from=footer',
    text: 'Тарифы и цены',
    name: 'price',
  },
  {
    href: '/contacts/',
    text: 'Помощь',
    name: 'contact',
    initHandler: () => {
      let feedbackTimeout: number;

      return {
        onClick: () => {
          const globalLog = getGlobalEventsLogs();

          globalLog.produce('feedback', { type: 'open', value: true });
          feedbackTimeout = window.setTimeout(() => {
            window.location.href = '/contacts/';
          }, 50);
        },
        effectHandler: () => {
          const feedbackConsumer = createConsumer({ topic: 'feedback' });

          const feedbackSubscriber = createSubscriber((event: IEvent<unknown>) => {
            if (event.type === 'popup_opened') {
              window.clearTimeout(feedbackTimeout);
            }
          });

          feedbackConsumer.subscribe(feedbackSubscriber);

          return () => {
            feedbackConsumer.unsubscribe(feedbackSubscriber);
            feedbackConsumer.destroy();
            window.clearTimeout(feedbackTimeout);
          };
        },
      };
    },
  },
  {
    href: '/help/re/advert/',
    text: 'Реклама на сайте',
    name: 'advert',
  },
  {
    href: '/help/add/fairplay/',
    text: 'Программа «Работаю честно»',
    name: 'fairplay',
  },
  {
    href: '/promo/adv/',
    text: 'Продвижение',
    name: 'promo',
  },
  {
    href: '/help/auction/',
    text: 'Аукцион',
    name: 'auction',
  },
  {
    href: '/map/',
    text: 'Поиск на карте',
    name: 'search_on_map',
  },
  {
    href: '/tv/',
    text: 'Реклама ЦИАН на ТВ',
    name: 'tv',
  },
  {
    href: '/vacancies/',
    text: 'Вакансии агентств',
    name: 'vacancies',
  },
  {
    href: '/ipoteka/calculator/',
    text: 'Ипотечный калькулятор',
    name: 'mortgage-calculator',
  },
  {
    href: '/legal-check/?source=footer',
    text: 'Проверка недвижимости',
    name: 'legal-check',
  },
];

const ADDITIONAL_LINKS: ILink[] = [
  {
    href: '/sitemap/',
    text: 'Карта сайта',
    name: 'sitemap',
  },
  {
    href: '/svezhie-obyavleniya/',
    text: 'Свежие объявления',
    name: 'svezhie-obyavleniya',
  },
];

const CAREER_LINK: ILink = {
  href: 'https://team.cian.tech/',
  text: 'Карьера в Циан',
  name: 'career',
  theme: 'primary',
};

export function getLinksList({ withAdditionalLinks }: IGetLinksListParameters): ILink[] {
  const baseLinks = BASE_LINKS.map(({ initHandler, ...rest }) => {
    if (initHandler) {
      return {
        ...initHandler(),
        ...rest,
      };
    }

    return rest;
  });

  return withAdditionalLinks ? [...baseLinks, ...ADDITIONAL_LINKS, CAREER_LINK] : [...baseLinks, CAREER_LINK];
}
